module.exports = __webpack_public_path__ + "img/EQUAL.08e92461.svg";